/**
 * How an RDP connection is handed to the user.
 */

import type { VmRdpInfo } from '../api/types.js';

export type RdpConnectMethod = 'download' | 'direct';

/**
 * Pick between downloading the .rdp file and showing a direct host:port link.
 *
 * In RDP gateway mode the gateway hostname and access token only travel in
 * the signed .rdp file, and no host-side port forward exists, so a direct
 * link can't work: always download, whatever the user's download_rdp
 * preference says.
 */
export function rdpConnectMethod(info: VmRdpInfo, downloadPref: boolean): RdpConnectMethod {
  if (info.gateway) return 'download';
  return downloadPref ? 'download' : 'direct';
}
